/**
 * @file: isRecordOnlySite.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { InspectionItemOptionInfo, InspectionSiteInfo } from '@euler/model';
import { AbnormalLevel, SeverityLevel } from '@euler/model/enum';

export function isRecordOnlySite(site: InspectionSiteInfo) {
  return (
    site.checkItems.length === 1 &&
    site.checkItems[0].options.length === 1 &&
    site.checkItems[0].options[0].abnormalLevel === AbnormalLevel.Fine
  );
}

export function onlyOptionOfSite(site: InspectionSiteInfo) {
  return site.checkItems[0]?.options[0];
}

export function getTargetFacadeSiteOptionInfo(site: InspectionSiteInfo) {
  let abnormalLevel: AbnormalLevel = AbnormalLevel.Fine;
  let severityLevel: SeverityLevel = SeverityLevel.None;
  let option: InspectionItemOptionInfo | undefined = undefined;
  if (isRecordOnlySite(site)) {
    option = onlyOptionOfSite(site);
  } else {
    option = site.checkItems[0]?.options.find(
      x => x.abnormalLevel !== AbnormalLevel.Fine,
    );
    abnormalLevel = option?.abnormalLevel ?? AbnormalLevel.Defective;
    severityLevel = option?.severityLevel ?? SeverityLevel.Warning;
  }
  return { abnormalLevel, severityLevel, option };
}
